import {connect} from "react-redux"
import {SuitSummaryData} from "../../models/searchApi/suit"
import State from "../../models/state"
import {
    formatPdpLink,
    formatSuitTitle,
    formatSuitTooltipTitle,
    suitPriceComponentAriaLabelText,
} from "../../utils/colourwayBuilders"

export const mapStateToProps = (state: State) => {
    const {
        template,
        productSummary: {colourwaysHasSale, brandedMarkdownSalePrice},
        text,
        request: {isEnglishLang},
    } = state
    const {colourways, title: defaultTitle, baseUrl, fit} = state.productSummary.summaryData as SuitSummaryData
    const associatedColourwayHasSale = colourways.some(colourway => Boolean(colourway?.associatedColourway?.salePrice))
    const selectedColourway = colourways.find(colourway => colourway.s)
    const jacketsHasSale = colourwaysHasSale
    const trousersHasSale = associatedColourwayHasSale
    const {
        t: title,
        id: colourwayItemNumber,
        p: price,
        wp: wasPrice,
        sp: salePrice,
        url,
        suitPrice,
        wasSuitPrice,
        saleSuitPrice,
        associatedColourway,
    } = selectedColourway as any

    const suitTitle = formatSuitTitle({
        title,
        defaultTitle,
        fit,
        selectedColourway,
        isEnglishLang,
    })

    const sharedAriaParams = {
        title: suitTitle,
        wasPriceText: text.price.was,
        salePriceText: text.price.now,
        isEnglishLang,
        jacketsHasSale,
        trousersHasSale,
    }

    return {
        templating: template,
        tooltipTitle: formatSuitTooltipTitle({
            title,
            defaultTitle,
            colourwayItemNumber,
            price,
            salePrice,
            fit,
            selectedColourway,
            isEnglishLang,
        }),
        linkUrl: formatPdpLink(baseUrl, url),
        jacketPrice: price,
        wasJacketPrice: wasPrice,
        saleJacketPrice: salePrice,
        suitPrice,
        wasSuitPrice,
        saleSuitPrice,
        trouserPrice: associatedColourway?.price,
        wasTrouserPrice: associatedColourway?.wasPrice,
        saleTrouserPrice: associatedColourway?.salePrice,
        text,
        jacketsHasSale,
        trousersHasSale,
        suitPriceAriaLabel: suitPriceComponentAriaLabelText({
            ...sharedAriaParams,
            price: suitPrice,
            wasPrice: wasSuitPrice,
            salePrice: saleSuitPrice,
            priceText: "Price",
        }),
        suitJacketPriceAriaLabel: suitPriceComponentAriaLabelText({
            ...sharedAriaParams,
            price,
            wasPrice,
            salePrice,
            priceText: "Jacket",
        }),
        suitTrousersPriceAriaLabel: suitPriceComponentAriaLabelText({
            ...sharedAriaParams,
            price: associatedColourway?.price,
            wasPrice: associatedColourway?.wasPrice,
            salePrice: associatedColourway?.salePrice,
            priceText: "Trousers",
        }),
        brandedMarkdownSalePrice,
    }
}

export default connect(mapStateToProps)
